module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 1072
// module chunks = 20